import http from '../utils/http';

let globalConfig;
/**
 * 获取系统全局配置
 * http://112.74.57.123:9101/workspace/myWorkspace.do?projectId=10#159
 *
 * @returns Promise
 */
export default function (cache = true) {

    // 有缓存直接使用缓存
    if (cache && globalConfig) {
        return Promise.resolve(globalConfig);
    }

    const request = http.post('/globalconfig', null, {
        needLogin: false
    }).then(v => {
        globalConfig = v;
        return v;
    });

    return request;
}
